module.exports = __webpack_public_path__ + "fonts/Cabin-VariableFont_wdth,wght.355e1554.ttf";